import { render } from "./PasswordResetComponent.vue?vue&type=template&id=0e17b8d2&scoped=true"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js"

import "./PasswordResetComponent.vue?vue&type=style&index=0&id=0e17b8d2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e17b8d2"]])

export default __exports__